import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const ASSISTANCE_PUSH = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    PUSH_REQUEST: null,
    PUSH_SUCCESS: null,
    SET_PUSH_INFO: null
  },
  'ASSISTANCE_PUSH'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/activity/virus/push/info',
        method: 'POST',
        body: data,
        requestAction: ASSISTANCE_PUSH.INIT_REQUEST,
        successAction: ASSISTANCE_PUSH.INIT_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

export function push(data, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/activity/virus/push',
        method: 'POST',
        body: data,
        requestAction: ASSISTANCE_PUSH.PUSH_REQUEST,
        successAction: ASSISTANCE_PUSH.PUSH_SUCCESS,
        success: function(result) {
          callback(result)
        }
      })
    )
  }
}

export function setPushInfo(data) {
  return (dispatch) => {
    dispatch({
      type: ASSISTANCE_PUSH.SET_PUSH_INFO,
      payload: JSON.parse(data)
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ASSISTANCE_PUSH.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [ASSISTANCE_PUSH.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [ASSISTANCE_PUSH.PUSH_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [ASSISTANCE_PUSH.PUSH_SUCCESS]: (state, action) => {
    const data = Object.assign({}, state, action.payload)
    // 保存当前助力信息，避免页面跳转回来重新请求
    sessionStorage.setItem('pushInfo', JSON.stringify(data))
    return data
  },
  [ASSISTANCE_PUSH.SET_PUSH_INFO]: (state, action) =>
    Object.assign({}, state, action.payload)
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'assistancePush',
    reducerMap: {
      assistancePushState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
